import { Head } from "components/Head";
import { Breadcrumbs, MainLayout } from "components/Layout";
import { useEffect } from "react";
import newsBgImg from "assets/images/banner/skills.jpeg";

export const EquateDocumentQualifications = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const routes = [
    {
      name: "Equate Document Qualifications",
      path: "/certify-academic-documents",
    },
  ];

  return (
    <MainLayout title="Equate Document Qualifications">
      <Head title="Equate Document Qualifications" />
      <div class="relative overflow-hidden h-80">
        <img
          src={newsBgImg}
          alt="Equate Document Qualifications"
          class="object-cover w-full h-full"
        />
        <div class="absolute w-full py-10 bottom-0 inset-x-0  text-white px-24 text-xs leading-4 bg-gradient-to-t from-black">
          <h1 className="text-6xl font-bold">Equate Document Qualifications</h1>
          <Breadcrumbs routes={routes} />
        </div>
      </div>
      <div className="mx-20 my-20"></div>
    </MainLayout>
  );
};
